import { API_CONFIG } from '../config/api';

export async function checkExistingAccount(token: string, email: string): Promise<{ exists: boolean; hasStorage: boolean }> {
  const url = `${API_CONFIG.BASE_URL}/auth/check-existing-account?email=${encodeURIComponent(email)}`;
  const res = await fetch(url, {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!res.ok) {
    return { exists: false, hasStorage: false };
  }
  const data = await res.json();
  return { exists: !!data.exists, hasStorage: !!data.hasStorage };
}

export async function prepareGuestAbandon(token: string, email: string): Promise<void> {
  const res = await fetch(`${API_CONFIG.BASE_URL}/auth/prepare-guest-abandon`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ email }),
  });
  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw new Error(data.error || 'Failed to prepare guest session handoff');
  }
}

export async function logoutAnonymousSession(token: string): Promise<void> {
  const res = await fetch(`${API_CONFIG.BASE_URL}/auth/logout-anonymous`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({}),
  });
  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw new Error(data.error || 'Failed to delete guest session');
  }
}

export async function abandonAnonymousSession(token: string, anonymousUid: string): Promise<void> {
  const res = await fetch(`${API_CONFIG.BASE_URL}/auth/abandon-anonymous`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ anonymousUid }),
  });
  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw new Error(data.error || 'Failed to abandon guest session');
  }
}

export async function completeCloudChoice(token: string): Promise<void> {
  const res = await fetch(`${API_CONFIG.BASE_URL}/auth/complete-cloud-choice`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({}),
  });
  if (!res.ok) {
    throw new Error('Failed to complete cloud choice');
  }
}

export async function upsertAuthUser(token: string, body: Record<string, unknown> = {}): Promise<{
  success: boolean;
  user?: { isAnonymous?: boolean; needsCloudChoice?: boolean };
  isNewUser?: boolean;
}> {
  const res = await fetch(`${API_CONFIG.BASE_URL}${API_CONFIG.ENDPOINTS.AUTH_USER}`, {
    method: 'PUT',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  });
  return res.json();
}
